import api from './index';
//
let exports = {};

// ============================ 盘点计划 ==========================
// 计划详情
exports.getDeviceStockCheckPlanInfo = function (data, callback) {
    api.post('/stock/check/plan/info/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getDeviceStockCheckPlanItemByFilter = function (data, callback) {
    api.post('/stock/check/plan/item/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 计划列表
exports.getDeviceStockCheckPlanList = function (data, callback) {
    api.post('/stock/check/plan/page/list')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 获取-某些机构的自盘负责人信息
exports.getPrincipalStaffMaps = function (data, callback) {
    api.post('/stock/check/plan/principal/staffMaps/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 保存、修改计划
exports.saveDeviceStockCheckPlan = function (data, callback) {
    api.post('/stock/check/plan/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getStockCheckAllowCheckList = function (data, callback) {
    api.post('/stock/check/allow/check/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 提交
exports.updateDeviceStockCheckPlanForApply = function (data, callback) {
    api.post('/stock/check/plan/apply/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 重新执行
exports.updateDeviceStockCheckPlanForAutoDone = function (data, callback) {
    api.post('/stock/check/plan/auto/done/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.updateDeviceStockCheckPlanItemForAutoDone = function (data, callback) {
    api.post('/stock/check/plan/auto/item/done/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 删除计划
exports.deleteDeviceStockCheckPlan = function (data, callback) {
    api.post('/stock/check/plan/delete/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// ============================ 盘点作业单 ==========================
//（零售）门店设备盘点单-分页查询
exports.getShopDeviceStockCheckVoucherList = function (params, callback) {
    api.post('/stock/check/stock/check/voucher/list/get')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
//（零售）门店设备盘点单-分页查询
exports.saveShopDeviceStockCheckVoucher = function (data, callback) {
    api.post('/stock/check/stock/check/voucher/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

//（零售）门店设备盘点单-开始
exports.doShopDeviceStockCheckVoucherStart = function (params, callback) {
    api.post('/stock/check/stock/check/voucher/start/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

//（零售）门店设备盘点单-结束
exports.doShopDeviceStockCheckVoucherEnd = function (params, callback) {
    api.post('/stock/check/stock/check/voucher/end/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

//（零售）门店设备盘点单-开始补盘
exports.doShopDeviceStockCheckVoucherMend = function (params, callback) {
    api.post('/stock/check/stock/check/voucher/mend/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

//（零售）门店设备盘点单-取消
exports.doShopDeviceStockCheckVoucherCancel = function (params, callback) {
    api.post('/stock/check/stock/check/voucher/cancel/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

exports.doShopDeviceStockCheckVoucherInvalid = function (params, callback) {
    api.post('/stock/check/stock/check/voucher/invalid/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

//（零售）门店设备盘点单-删除
exports.deleteShopDeviceStockCheckVoucher = function (params, callback) {
    api.post('/stock/check/stock/check/voucher/delete/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
//（零售）门店设备盘点单-负责人确认
exports.doShopDeviceStockCheckVoucherConfirm = function (params, callback) {
    api.post('/stock/check/stock/check/voucher/confirm/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

//（零售）门店设备盘点单-抽盘人确认
exports.doShopDeviceStockCheckVoucherSpotConfirm = function (params, callback) {
    api.post('/stock/check/stock/check/voucher/spot/confirm/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
//（零售）门店设备盘点单-指定自盘负责人
exports.updateShopDeviceStockCheckVoucherPrincipal = function (params, callback) {
    api.post('/stock/check/stock/check/voucher/update/principal/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

//（零售）门店设备盘点单-指定抽盘负责人
exports.updateShopDeviceStockCheckVoucherSpotPrincipal = function (params, callback) {
    api.post('/stock/check/stock/check/voucher/update/spotPrincipal/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
// 上传盘点附件-操作
exports.saveShopDeviceStockFile = function (data, callback) {
    api.post('/stock/check/device/stock/file/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getShopDeviceStockCheckItemList = function (params, callback) {
    api.post('/stock/check/stock/check/item/list/get')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
// 获取结果执行清单列表
exports.getShopDeviceStockCheckItemHandleList = function (params, callback) {
    api.post('/stock/check/stock/check/item/handle/list/get')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
// 异常项
exports.getShopDeviceStockCheckAbnormalItemList = function (params, callback) {
    api.post('/stock/check/stock/check/abnormal/item/list/get')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
// 提交盘点明细导出过滤参数，返回导出文件所需uuid
exports.saveDeviceCheckItemParamsForExport = function (data, callback) {
    api.post('/stock/check/exp/check/item/params/for/export/url')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
}
// 提交盘点明细导出数据，返回导出文件所需uuid
exports.saveDeviceCheckItemModelForExport = function (data, callback) {
    api.post('/stock/check/exp/check/item/model/for/export/url')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
}
// （零售）门店设备盘点处理-导出贴码-需补码
exports.doShopDeviceStockHandleTagMissing = function (params, callback) {
    api.post('/stock/check/stock/handle/tagMissing/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
//（零售）门店设备盘点单-根据id查询
exports.getShopDeviceStockCheckVoucher = function (params, callback) {
    api.get('/stock/check/stock/check/voucher/get/by/id')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.doShopDeviceStockCheckVoucherRestart = function (params, callback) {
    api.post('/stock/check/stock/check/voucher/restart/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
// 盘点作业单统计数量信息
exports.getShopDeviceStockCheckVoucherStatisCount = function (data, callback) {
    api.post('/stock/check/voucher/statis/count/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 查询盘点附件-操作
exports.getServcWorkImgFileListByVoucherId = function (data, callback) {
    api.post('/stock/check/device/stock/file/get/by/voucherId')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 盘点结果 - 刷新实时数量
exports.doRefreshShopDeviceStockCheckItemUttInfo = function (data, callback) {
    api.post('/stock/check/item/uttInfo/refresh/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// ============================ 盘后处理单 ==========================
// 详情
exports.getShopDeviceStockHandelVoucherInfo = function (data, callback) {
    api.post('/stock/check/handle/voucher/info/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 列表
exports.getShopDeviceStockHandelVoucherList = function (data, callback) {
    api.post('/stock/check/handle/voucher/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 新增
exports.saveShopDeviceStockHandleVoucher = function (data, callback) {
    api.post('/stock/check/handle/voucher/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 提交
exports.submitShopDeviceStockHandleVoucher = function (data, callback) {
    api.post('/stock/check/handle/voucher/submit/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 审核
exports.auditShopDeviceStockHandleVoucher = function (data, callback) {
    api.post('/stock/check/handle/voucher/audit/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 作废
exports.doShopDeviceStockHandleVoucherInvalid = function (data, callback) {
    api.post('/stock/check/handle/voucher/invalid/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
// 删除
exports.deleteShopDeviceStockHandleVoucher = function (data, callback) {
    api.post('/stock/check/handle/voucher/delete/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.doShopDeviceStockHandleVoucherDone = function (data, callback) {
    api.post('/stock/check/handle/item/done/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getShopDeviceStockCheckVoucherStatisList = function (params, callback) {
    api.post('/stock/check/stock/check/voucher/statis/list/get')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.doShopDeviceStockHandleVoucherHandleFinished = function (params, callback) {
    api.post('/stock/check/handle/voucher/handle/finished/do')
        .data(params)
        .done(callback)
        .fail(callback)
        .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/stockCheck.js
// module id = 73
// module chunks = 0